import { useQuery } from 'react-apollo';
import { services } from '../queries';

export function useServices() {
  const { data, refresh, loading: isLoading } = useQuery(services, {
    fetchPolicy: 'cache-first',
  });
  const list = (data?.services ?? [])
    .map(sr => ({ ...sr, id: sr.dbId }))
    .filter(sr => sr.version === 'v4');
  return { services: list, refresh, isLoading };
}
